var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "15px",
    height: "15px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -1185 -401 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.2988668555241 0  C 14.5963172804533 0  14.8052407932011 0.138494318181819  14.9256373937677 0.415482954545455  C 15.0460339943343 0.706676136363635  14.9964589235127 0.955255681818181  14.7769121813031 1.16122159090909  L 9.53966005665722 6.41335227272727  L 9.53966005665722 14.3181818181818  C 9.53966005665722 14.6164772727273  9.40155807365439 14.8259943181818  9.12535410764873 14.9467329545455  C 9.03328611898017 14.9822443181818  8.94475920679887 15  8.85977337110482 15  C 8.6685552407932 15  8.50920679886686 14.9325284090909  8.38172804532578 14.7975852272727  L 5.66218130311615 12.0703125  C 5.52762039660057 11.9353693181818  5.46033994334278 11.7755681818182  5.46033994334278 11.5909090909091  L 5.46033994334278 6.41335227272727  L 0.223087818696884 1.16122159090909  C 0.00354107648725212 0.955255681818181  -0.0460339943342776 0.706676136363635  0.0743626062322946 0.415482954545455  C 0.194759206798867 0.138494318181819  0.403682719546742 0  0.701133144475921 0  L 14.2988668555241 0  Z ",
    fillRule: "nonzero",
    fill: "#aaaaaa",
    stroke: "none",
    transform: "matrix(1 0 0 1 1185 401 )"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon-filter.9c68cd7adac1157a2b2ddf1766d00473.svg";
export { ForwardRef as ReactComponent };